import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, toggle: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("mh_lang") || "en";
  });

  useEffect(() => {
    window.localStorage.setItem("mh_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "fr" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

export function useT(copyMap) {
  const { lang } = useLang();
  return copyMap[lang] || copyMap.en;
}

export function LangToggle({ variant = "light", testId = "lang-toggle" }) {
  const { lang, toggle } = useLang();
  const styles =
    variant === "dark"
      ? "border-white/30 text-white hover:border-white"
      : variant === "activist"
        ? "border-white/40 text-white hover:bg-white hover:text-black"
        : "border-slate-300 text-slate-700 hover:border-slate-900 hover:text-slate-900";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testId}
      aria-label={`Switch to ${lang === "en" ? "French" : "English"}`}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[10px] tracking-[0.25em] uppercase transition-colors ${styles}`}
    >
      <span className={lang === "en" ? "opacity-100" : "opacity-40"}>EN</span>
      <span className="opacity-40">/</span>
      <span className={lang === "fr" ? "opacity-100" : "opacity-40"}>FR</span>
    </button>
  );
}
